import { ColorType } from "./AHTheme/AHTheme";
import { IconSize } from "./LayoutProvider";

import { BoxProps } from "./AHTheme/BoxProps";
import React from "react";
import { TeamIcon } from "../globalTypes";
import { useFragment, graphql } from "react-relay";
import { AHTeamIcon$key } from "./__generated__/AHTeamIcon.graphql";
import { AHIcon, AHIconType } from "./AHIcon";

type TeamIconProps = {
  type: TeamIcon | null | keyof typeof TeamIcon;
  size?: IconSize;
  color?: ColorType;
  customColor?: string;
} & Omit<BoxProps, "color">;

const iconMap: Record<TeamIcon, AHIconType> = {
  [TeamIcon.account_hard_hat]: "account-hard-hat",
  [TeamIcon.account_tie]: "account-tie",
  [TeamIcon.apple]: "apple",
  [TeamIcon.baby_carriage]: "baby-carriage",
  [TeamIcon.baguette]: "baguette",
  [TeamIcon.basket]: "basket",
  [TeamIcon.bed]: "bed",
  [TeamIcon.bread_slice]: "bread-slice",
  [TeamIcon.broom]: "broom",
  [TeamIcon.carrot]: "carrot",
  [TeamIcon.cart]: "cart",
  [TeamIcon.cash]: "cash",
  [TeamIcon.cash_register]: "cash-register",
  [TeamIcon.cheese]: "cheese",
  [TeamIcon.coffe]: "coffe",
  [TeamIcon.cookie]: "cookie",
  [TeamIcon.cupcake]: "cupcake",
  [TeamIcon.default]: "account-group",
  [TeamIcon.desk_lamp]: "desk-lamp",
  [TeamIcon.dolly]: "dolly",
  [TeamIcon.fish]: "fish",
  [TeamIcon.flower]: "flower",
  [TeamIcon.food]: "food",
  [TeamIcon.fork_knife]: "fork-knife",
  [TeamIcon.forklift]: "forklift",
  [TeamIcon.fridge]: "fridge",
  [TeamIcon.hamburger]: "hamburger",
  [TeamIcon.hammer_wrench]: "hammer-wrench",
  [TeamIcon.laptop]: "laptop",
  [TeamIcon.market]: "market",
  [TeamIcon.meat]: "meat",
  [TeamIcon.milk]: "milk",
  [TeamIcon.pineapple]: "pineapple",
  [TeamIcon.soda]: "soda",
  [TeamIcon.sofa]: "sofa",
  [TeamIcon.steak]: "steak",
  [TeamIcon.tshirt]: "tshirt",
  [TeamIcon.tv]: "tv-sharp",
  [TeamIcon.watermelon]: "watermelon",
};

export function AHTeamIcon(props: TeamIconProps) {
  const { type: teamType, color, size, customColor, ...boxProps } = props;

  const type = TeamIcon[teamType ?? TeamIcon.default];
  const icon = iconMap[type];

  if (!icon) {
    return null;
  }

  return (
    <AHIcon
      type={icon}
      color={color}
      size={size}
      customColor={customColor}
      {...boxProps}
    />
  );
}

export function AHTeamIconRelay(
  props: Omit<TeamIconProps, "type"> & {
    team: AHTeamIcon$key;
  }
) {
  const { icon } = useFragment(
    graphql`
      fragment AHTeamIcon on Team {
        icon
      }
    `,
    props.team
  );

  return <AHTeamIcon {...props} type={icon} />;
}
